export default __webpack_public_path__ + "static/media/RetailBg.4930f91a.svg";